import { Log } from "src/app/utils/log";

export interface EnvConfig {
  production: boolean;
  offlineMode?: boolean;
  /**
   * True for a build that compiles in `offlineMode: true` (the self-contained e2e build), so dev
   * tools can tell it apart from offline mode switched on via the runtime `dev.offlineMode` override —
   * a stored override from an earlier dev session must not make such a build reach real services.
   */
  offlineModeHardcoded?: boolean;
  enableAllServiceMocks?: boolean;
  enableAllPrognosisMocks?: boolean;
  skipConsents?: boolean;
  appVersion?: string;
  logLevel?: Log.Level;
  restApiRootUrl: string;
}

export const applicationId = "387e5e03-6fc9-434e-bb93-1c79bf665a7e";
export const clientToken = "pub9a3c74e7dfb88a494f734f262e656e73";
